import clsx from "classnames";
import classes from "./styles.module.scss";

export default function HeaderTitle({ title, color, tag, fontSize, lineHeight, className }) {

  const HeaderTag = tag || 'h1';

  return (
    <HeaderTag className={clsx(className, classes.header_title)} style={{fontSize: fontSize, lineHeight: lineHeight}}>
      {title}
      <div className={classes.title_block} style={{backgroundColor: color}}></div>
    </HeaderTag>
  );
}

HeaderTitle.defaultProps = {
  className: "",
};
